import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import AddCircleIcon from 'grommet/components/icons/base/AddCircle';
import SubtractCircleIcon from 'grommet/components/icons/base/SubtractCircle';

export default class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
      isExpanded: this.props.isExpanded
    }
  }
  componentWillMount() {}

  componentWillUpdate(nextProps, nextState) {
    //this.getContent(nextProps.config.path); 
  }

  render() {
    if(!this.props.render){
      return false;
    }
    let content = Utils.getDangerousHtml(this.state.content);
    let ToggleContentIcon = this.props.isExpanded ? SubtractCircleIcon : AddCircleIcon;
    let buttonProps = {
      className: this.props.showAcceptButton ? 'accept-button' : 'toggle-button',
      onClick: (e) => {
        e.preventDefault();
        this.props.onClick(e);
      }

    }
    if(this.props.showAcceptButton){
      return (
        <span className="toggle-button-container"><button {...buttonProps}>Accept</button></span>
      );
    }
    return (
      <span className="toggle-button-container"><button {...buttonProps}><ToggleContentIcon /></button></span>
    );
  }
}

ToggleButton.propTypes = {
  onClick: React.PropTypes.func,
  isExpanded: React.PropTypes.bool,
  render: React.PropTypes.bool,
  showAcceptButton: React.PropTypes.bool
}
ToggleButton.defaultProps = {
  onClick: () => {},
  isExpanded: false,
  render: false,
  showAcceptButton: false
}


// WEBPACK FOOTER //
// ./src/app/isi/toggle-button.jsx